import React from 'react';
import { CustomerServiceView } from './view';
import { useCustomerServiceModel } from './model';

export const CustomerServiceWidget: React.FC = () => {
  const model = useCustomerServiceModel();

  return (
    <CustomerServiceView
      state={model.state}
      onDraftChange={model.setMessageDraft}
      onSend={() => void model.sendMessage()}
      onRefresh={() => void model.refresh()}
    />
  );
};
